import updateSelectFromArray from '../../new-car-pages/modules/details/finance/finance-types/update-select-from-array';
import flatpickr from "flatpickr";
import differenceInHours from 'date-fns/difference_in_hours';

let alreadySetup = false;
let bookAppointmentValidator = false;
let bookAppointmentLocationHandler = false;
let bookAppointmentDateChangeEvent = false;
let bookAppointmentFormElement = false;
let bookableTimes = [];
let bookableDates = [];
let currentDealer = false;
let datePicker = false;
let isMaterialForm = false;
let valuationWidget;
const jsDateToPhpDate = {
    0: 6,
    1: 0,
    2: 1,
    3: 2,
    4: 3,
    5: 4,
    6: 5,
};

const renderBookableTimes = function() {
    // Get the currently selected date, find the index it should be (the index is the PHP day of the week number)
    const selectedElement = bookAppointmentFormElement.querySelector('input[name="appointment_date"]:checked');
    const target = bookAppointmentFormElement.querySelector('select[name="appointment_time"]');
    if (!selectedElement) {
        if (isMaterialForm) {
            updateSelectFromArray(
                [
                    'Please select a date first',
                ],
                target,
                value => value,
                value => ''
            );
        } else {
            updateSelectFromArray(
                [
                    'Appointment date *',
                ],
                target,
                value => value,
                value => ''
            );
        }
        target.classList.add('active');
        // $(target).trigger('change.validator');
        return;
    }

    let dayOfTheWeek;
    let isTomorrow = false;

    if (selectedElement.value == 'Other') {
        bookAppointmentFormElement.querySelector('[data-other-date-input]').style.display = 'block';
        bookAppointmentFormElement.querySelector('[name="other-date"]').dataset.validate = "input";
        bookAppointmentFormElement.querySelector('[name="other-date"]').dataset.validateMessage = "Please select an appointment date";
        bookAppointmentValidator.updateValidatableElements();
        dayOfTheWeek = datePicker.selectedDates;
        if (typeof dayOfTheWeek != 'object' || dayOfTheWeek.length == 0) {
            // todo invalid day of the week
        } else {
            if (differenceInHours(dayOfTheWeek[0], Date.now()) <= 24) {
                isTomorrow = true;
            }
            dayOfTheWeek = jsDateToPhpDate[dayOfTheWeek[0].getDay()];
        }
    } else {
        bookAppointmentFormElement.querySelector('[data-other-date-input]').style.display = 'none';
        bookAppointmentFormElement.querySelector('[name="other-date"]').dataset.validate = null;
        bookAppointmentValidator.updateValidatableElements();
        dayOfTheWeek = selectedElement.dataset.day;
        if (selectedElement.dataset.index == 0) {
            isTomorrow = true;
        }
    }

    let times = [];
    if (typeof bookableTimes[dayOfTheWeek] == 'undefined') {
        if (isTomorrow) {
            if (isMaterialForm) {
                times = [
                    '',
                    'Afternoon',
                ];
            } else {
                times = [
                    'Appointment time *',
                    'Afternoon',
                ];
            }
        } else {
            if (isMaterialForm) {
                times = [
                    '',
                    'Morning',
                    'Afternoon',
                ];
            } else {
                times = [
                    'Appointment time *',
                    'Morning',
                    'Afternoon',
                ];
            }
        }
    } else {
        if (isMaterialForm) {
            times = [
                '',
            ];
        } else {
            times = [
                'Appointment time *',
            ];
        }

        for (let index = 0, len = bookableTimes[dayOfTheWeek].length; index < len; index++) {
            const time = bookableTimes[dayOfTheWeek][index];
            if (isTomorrow) {
                if (time.indexOf('AM') >= 0) {
                    continue;
                }
                if (time == '12:00 PM') {
                    continue;
                }
            }
            times.push(time);
        }
    }
    updateSelectFromArray(times, target);
    $(target).trigger('change.validator');
}

const renderBookableDates = function() {
    const bookableDateSlots = bookAppointmentFormElement.querySelectorAll('input[name="appointment_date"]');
    // Set the value of each radio button to the booking dates returned by the API
    bookableDateSlots.forEach(bookableDateSlot => {
        if (bookableDateSlot.value == 'Other') {
            return;
        }
        const index = bookableDateSlot.dataset.index || 0;
        const label = bookAppointmentFormElement.querySelector('label[for="'+bookableDateSlot.getAttribute('id')+'"');
        if (typeof bookableDates[index] == 'undefined') {
            if (label) {
                label.innerHTML = '-';
                label.style.display = 'none';
            }
            return;
        }
        bookableDateSlot.value = bookableDates[index][1];
        bookableDateSlot.dataset.day = bookableDates[index][0];
        if (label) {
            label.innerHTML = bookableDates[index][1];
            if (label.style.display == 'none') {
                label.style.display = null;
            }
        }
    });
}


const getBookableDatesAndTimesForDealer = function(dealerId) {
    return new Promise((resolve, reject) => {
        if (dealerId == '') {
            reject('Empty dealer ID');
            return;
        }

        if (dealerId == currentDealer) {
            resolve("Dealer hasn't changed");
            return;
        }

        $.ajax({
            type: "POST",
            cache: true,
            dataType: 'json',
            url: '/valuation/appointment-dates',
            data: {
                'location-id': dealerId,
            },
            success: response => {
                bookableDates = response.dates || [];
                bookableTimes = response.opening_times || [];
                currentDealer = dealerId;
                renderBookableDates();
                renderBookableTimes();
                if (datePicker) {
                    datePicker.redraw();
                }
                resolve(response);
            },
            error: response => {
                console.error(response);
                reject(response);
            }
        });
    });
}

const submitAppointment = function(event) {
    event.preventDefault();
    if (bookAppointmentValidator == false) {
        return;
    }

    valuationWidget.postDataFromForm(bookAppointmentValidator, '#submitAppointment')
    .then(response => {
        // The false response means either it failed validation, or the form itself couldn't be found
        if (response === false) {
            // There might be validation errors within the customer details section, so lets check if there are
            const errorsWithinCustomerDetails = bookAppointmentFormElement.querySelector('#submitAppointment .valuation-widget__book-appointment-customer .validation-error');
            if (errorsWithinCustomerDetails) {
                bookAppointmentFormElement.querySelector('#submitAppointment .valuation-widget__book-appointment-customer').style.display = 'flex';
            }
            return;
        }

        valuationWidget.setCtaUrls(response);
        valuationWidget.dealerName = response.dealer.name || 'your chosen dealer';
        valuationWidget.appointmentDate = response.date;
        valuationWidget.appointmentTime = response.time;
        valuationWidget.setState('final-thank-you')
    })
    .catch(errorData => {
        console.error('ValuationWidget@getValuation - Something went wrong: ', errorData);
    });
}

const initialSetup = function(targetFormElement, ValuationWidget) {
    if (!targetFormElement) {
        console.error("Couldn't setup book appointment form as the target element doesn't exist", targetFormElement);
        return;
    }
    bookAppointmentFormElement = targetFormElement;
    if (bookAppointmentFormElement.classList.contains('material-form')) {
        isMaterialForm = true;
    }
    valuationWidget = ValuationWidget;
    if (alreadySetup === true) {
        return;
    }
    alreadySetup = true;

    bookAppointmentFormElement.addEventListener('submit', submitAppointment);

    // The marketing preferences are meant to be carried over from the previous step, but we don't want to show them apparently
    // So we need to remove the validation
    const marketingPreferences = bookAppointmentFormElement.querySelectorAll('[name="marketing_preference"]');
    marketingPreferences.forEach(marketingPreference => {
        marketingPreference.dataset.validate = null;
    });

    const privacyTerms = bookAppointmentFormElement.querySelector('[name="privacy-terms"]');
    if (privacyTerms) {
        privacyTerms.dataset.validate = null;
    }

    // Populate the inputs with any customer details we have saved from previous steps
    Object.keys(ValuationWidget.customerDetails).forEach(key => {
        if (key == 'referrer') {
            return;
        }

        if (key == 'marketing_preference') {
            const elementsToUpdate = bookAppointmentFormElement.querySelectorAll('[name="'+key+'"]');
            elementsToUpdate.forEach(element => {
                if (element.value == ValuationWidget.customerDetails[key]) {
                    element.checked = true;
                    return;
                }
                element.checked = false;
            });
            return;
        }

        const elementToUpdate = bookAppointmentFormElement.querySelector('[name="'+key+'"]');
        if (!elementToUpdate) {
            return;
        }

        if (key == 'location-id') {
            elementToUpdate.dataset.initialLocationId = ValuationWidget.customerDetails[key];
        }

        if (elementToUpdate.getAttribute('type') == 'checkbox') {
            elementToUpdate.checked = true;
            return;
        }

        elementToUpdate.value = ValuationWidget.customerDetails[key];
    });

    bookAppointmentFormElement.querySelector('[data-other-date-input]').style.display = 'none';
    bookAppointmentFormElement.querySelector('[name="other-date"]').dataset.validate = null;

    if (bookAppointmentValidator === false) {
        bookAppointmentValidator = new ContactFormValidator({
            element: bookAppointmentFormElement,
            loadingHtml: `<div class="loading">${ValuationWidget.loadingImage}</div>`,
        });
    }

    if (bookAppointmentLocationHandler === false) {
        const bookAppointmentFormDealer = bookAppointmentFormElement.querySelector('[name="location-id"]');
        if (ValuationWidget.fixedDealer == 0) {
            bookAppointmentLocationHandler = new CustomerLocationHandler({
                additionalLocationFilterFunction: ValuationWidget.dealerFilter,
                element: bookAppointmentFormElement
            });

            bookAppointmentFormDealer.addEventListener('sorted', () => {
                getBookableDatesAndTimesForDealer(bookAppointmentFormDealer.value);
            });

            bookAppointmentFormDealer.addEventListener('change', () => {
                getBookableDatesAndTimesForDealer(bookAppointmentFormDealer.value);
            });
        } else {
            getBookableDatesAndTimesForDealer(bookAppointmentFormDealer.value);
        }
    }

    // Setup the date change event once only
    if (bookAppointmentDateChangeEvent === false) {
        const otherDateInput = bookAppointmentFormElement.querySelector('input[name="other-date"]');
        datePicker = flatpickr(otherDateInput, {
            minDate: new Date().fp_incr(1),
            altInput: true,
            altFormat: 'l j F Y',
            dateFormat: 'l j F Y',
            "locale": {
                "firstDayOfWeek": 1
            },
            disable: [
                date => {
                    const dayStartOnMonday = date.getDay() === 0 ? 6 : date.getDay() - 1;
                    return (typeof bookableTimes[dayStartOnMonday] != 'object' || bookableTimes[dayStartOnMonday].length == 0);
                }
            ],
            onChange: function() {
                renderBookableTimes();
            },
        });
        otherDateInput.addEventListener('change', function() {
            if (this.value != '') {
                this.parentNode.querySelectorAll('label').forEach(element => {
                    element.classList.add('active');
                });
                return;
            }
            this.parentNode.querySelectorAll('label').forEach(element => {
                element.classList.remove('active');
            });
        });

        bookAppointmentFormElement.querySelectorAll('input[name="appointment_date"]').forEach(dateRadioInput => {
            dateRadioInput.addEventListener('change', (event) => {
                renderBookableTimes();
            });
        });

        const appointmentTimeElement = bookAppointmentFormElement.querySelector('[name="appointment_time"]');
        if (appointmentTimeElement) {
            const showHideAppointmentTimeLabel = function() {
                if (appointmentTimeElement.options.length != 2) {
                    return;
                }
                if (appointmentTimeElement.options[1].innerHTML == 'Please select a date first') {
                    appointmentTimeElement.classList.add('active');
                }
            };
            showHideAppointmentTimeLabel();
            appointmentTimeElement.addEventListener('change', function() {
                showHideAppointmentTimeLabel();
            });
            setTimeout(showHideAppointmentTimeLabel, 50);
        }

        bookAppointmentDateChangeEvent = true;
    }
}

export { initialSetup };


// WEBPACK FOOTER //
// ./resources/assets/js/valuations/modules/book-appointment-form.js